.weight-column {
  width: 100%;
  text-align: right;
}
